import { Component, OnInit } from '@angular/core';
import { Principal } from '@otas/shared/auth/principal.service';

@Component({
    selector: 'app-authenticated',
    template: '<fw-body ></fw-body>  ',
    standalone: false
})
export class AuthenticatedComponent implements OnInit {

  constructor(private principal: Principal) {
    // if (this.cookieService.check('CURRENT_USER')) {
    //   this.atoc.storeCartDetailsIntoDBWhileLogin();
    // }
  }

  ngOnInit() {
    // this.principal.identity(true).then((res) => { });
  }
  isAuthenticated() {
    return this.principal.isAuthenticated();
  }
}
